import script from "./CuraproxTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./CuraproxTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./CuraproxTemplate.vue?vue&type=style&index=0&id=360f119a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360f119a"]])

export default __exports__